import { Component, OnInit, ViewChild } from '@angular/core';

import { CustomStore, ArkUnitOfWork, BreezeDxStoreService, AppInformationService, UtilityService, AuthService } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import { Person } from 'app/core/model/entity-model';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Predicate } from 'breeze-client';
import { alert } from 'devextreme/ui/dialog';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';

@Component({
    selector: 'app-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [DevExtremeModule]
})
export class ListComponent implements OnInit {
    store: CustomStore;
    people: Person[];
    selectedView = 'Directory';
    canSeeBudgetBox = false;
    peopleAdmin = false;

    @ViewChild('peopleGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        public appInfo: AppInformationService,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        private utility: UtilityService,
        public auth: AuthService,
    ) {}

    async ngOnInit() {
        await this.getData();
        this.canSeeBudgetBox = this.auth.hasRole('PeopleAdmin') || this.auth.hasRole('Administrator')
        this.peopleAdmin = this.auth.hasRole('PeopleAdmin');
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const orPredicate = new Predicate('familyId', '==', null).or('family.includeInDirectory', '==', true)
        let predicate = new Predicate('includeInDirectory', '==', true).and(orPredicate);
        if (this.selectedView === 'All') predicate = null;
        this.people = await this.uow.people.where(predicate, 'lastName,firstName', 'family');
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'before',
            }
        );
    }

    rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data.id);
    }

    setFocusedRowKey(key) {
        this.dataGrid.selectedRowKeys = [];
        this.dataGrid.focusedRowKey = key;
        sessionStorage.setItem(this.dataGrid.stateStoring.storageKey, JSON.stringify(this.dataGrid.instance.state()));
    }

    selectedViewChanged() {
        this.getData();
    }

    open(personId?) {
        if (!this.peopleAdmin) return;
        if (!!personId) this.router.navigate(['../' + personId], { relativeTo: this.route });
        else this.router.navigate(['../' + 'new'], { relativeTo: this.route });
    }

    add(type: any) {
        if (type === 'family') this.router.navigate(['../families/' + 'new'], { relativeTo: this.route });
    }

    async printNominationForm(personId) {
        const role = await this.getRole('Select Role', 'select', ['Deacon', 'Shepherding Elder', 'Executive Elder']);
        const roughDate = new Date(new Date().getFullYear(), 1, 20 );  // set for Feb, ts goes 0-11 for months
        const dueDate = await this.getRole('Select Due Date', 'date', null, roughDate);
        const result = await this.utility.getNominationLetter(personId, dueDate, role);
    }

    async getRole(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }

    async printPictureDirectory() {
        const result = await this.utility.printPictureDirectory();
    }
}
